import {ErrorEvent, IErrorEvent} from '../../../api/network';
import {IMCMethodEditChatResponse, MCMethodEditChatResponse} from '../../../api/proto';
import i18n from '../../../i18n';
import formatTimeout from '../../../utils/format/formatTimeout';

export function getEditChatErrorMessage(error?: IErrorEvent | null, res?: IMCMethodEditChatResponse | null): string | null {
  if (error) {
    return error.message || 'Unknown error';
  }

  switch (res?.result) {
    case MCMethodEditChatResponse.Result.R_OK:
      return null;
    case MCMethodEditChatResponse.Result.R_UNKNOWN:
      return i18n.t('edit_chat_error_unknown');
    case MCMethodEditChatResponse.Result.R_CHANNEL_NOT_FOUND:
      return i18n.t('edit_chat_error_channel_not_found');
    case MCMethodEditChatResponse.Result.R_CHAT_NOT_FOUND:
      return i18n.t('edit_chat_error_chat_not_found');
    case MCMethodEditChatResponse.Result.R_CHAT_TITLE_FLOOD_ERROR: {
      return i18n.t('edit_chat_error_chat_title_flood', {timeout: formatTimeout(res?.timeout)});
    }
    case MCMethodEditChatResponse.Result.R_CHAT_DESCRIPTION_FLOOD_ERROR: {
      return i18n.t('edit_chat_error_chat_description_flood', {timeout: formatTimeout(res?.timeout)});
    }
    case MCMethodEditChatResponse.Result.R_CHAT_PHOTO_FLOOD_ERROR: {
      return i18n.t('edit_chat_error_chat_photo_flood', {timeout: formatTimeout(res?.timeout)});
    }
    case MCMethodEditChatResponse.Result.R_INTERNAL_SERVER_ERROR:
      return i18n.t('edit_chat_error_internal_server_error');
  }

  if (res?.result !== undefined && res?.result !== null) {
    const key = MCMethodEditChatResponse.Result[res.result];
    if (key) {
      return key.toLowerCase().replace('r_', '').replace(/_/g, ' ');
    }
  }

  return null;
}

export default function getEditChatError(error?: IErrorEvent | null, res?: IMCMethodEditChatResponse | null): IErrorEvent | null {
  if (error) {
    return error;
  }

  const message = getEditChatErrorMessage(error, res);
  if (message) {
    return new ErrorEvent({message});
  }

  return null;
}
